<template>
    <v-container>
        <v-dialog v-model="mostrarExcluir" persistent max-width="70vw" scrollable>
            <v-card :loading="loading">
                <v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
                <v-divider></v-divider>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <h2 class="text-center">Você está excluindo a publicação "{{publicacaoExcluir.titulo}}"</h2>
                            <h3 class="text-center">Confirma a exclusão?</h3>
                        </v-col>
                    </v-row>
                </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.stop="confirmar()">Confirmar</v-btn>
                    <v-btn text color="primary" @click.stop="mostrarExcluir = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="mostrar" persistent max-width="70vw" >
            <v-card :loading="loading">
                <v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
                <v-divider></v-divider>
                <v-data-table locale="pt-BR" 
                                dense fixed-header 
                                class="table-item" 
                                :items="publicacoes" 
                                :headers="fields" 
                                :items-per-page="15">

                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon color="primary" @click="ler(item)">
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                                <v-btn v-on="on" icon class="mx-1" color="primary" @click="ativar(item)">
                                    <v-icon>mdi-check</v-icon>
                                </v-btn>
                            </template>
                            <span>Confirmar</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon color="primary"  @click="excluir(item)">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Excluir</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container> 
</template>

<script>
import Br from '@/config/barramento.js'
import axios from 'axios'
import { baseApiUrl, showSuccess, showError } from "@/config/global"

export default {
    data(){
        return{
            publicacoes: [],
            fields: [
					{value: 'nome', text: 'Nome'},
					{value: 'data', text: 'Data'},
					{value: 'grau', text: 'Grau'},
					{value: 'autor', text: 'Autor'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
                ],
            mostrar: false,
            loading: false,
            mostrarExcluir: false,
            publicacaoExcluir: {},
            cor: 'primary',
        }
    },
    methods:{
        ativar(item){
            const url = `${baseApiUrl}/estudos/ativar.php` 
				        
            axios.post(url, item).then(res => {
                
                if(res.data.codigo == '01'){
                    showSuccess(res.data.mensagem)	
                    this.atualizarRegistro(item, res.data.status)

                }else{
                    showError(res.data.mensagem)
                }
                
            })
        },

        ler(item){
            Br.setLerPublicacao(item)
        },

        atualizarRegistro(item, destino){

				let idx = this.publicacoes.findIndex((v) => {

                    return v.id == item.id
                })

                this.publicacoes.splice(idx, 1)
                item.destino = destino
                Br.setPublicacaoAtivada(item)
                if(this.publicacoes.length == 0){
                    this.fechar()
                    showSuccess("Não há mais publicações inativas")
                }
			},

        excluir(item){
            this.publicacaoExcluir = item
            this.mostrarExcluir = true
        },

        confirmar(){
            const url = `${baseApiUrl}/estudos/delete.php` 
				
            axios.post(url, this.publicacaoExcluir).then(res => {
            
                if(res.data.codigo == '01'){
                    showSuccess(res.data.mensagem)
                    let idx = this.publicacoes.findIndex((v) => {
                        return v.id == this.publicacaoExcluir.id
                    })
                    Br.setPublicacaoExcluida(this.publicacaoExcluir)
                    this.publicacaoExcluir = {}
                    this.fecharExcluir()
                    this.publicacoes.splice(idx, 1)

                }else{
                    showError(res.data.mensagem)
                }
                
            })
        },

        fechar(){
            this.mostrar = false
        },

        fecharExcluir(){
            this.mostrarExcluir = false
        }
    },

    created(){
        Br.onAbrirPublicacoesInativas(publicacoes => {
            this.publicacoes = publicacoes
            this.mostrar = true
        })
    }
}
</script>